import { get } from "../../xhr/api";

export const get_request_details = (id) => get(`api/tax-dispute/requests/${id}`,{}, true)